import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Col, Row } from 'antd';
import Button from 'components/Button';
import { getOptions, plugin, handleDownloadImage } from './GraficoBarrasVertical';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const GraficoBarrasVertical = ({ title, dados, style }) => {
  let ref = useRef(null);

  const options = getOptions(title);

  const downloadImage = useCallback(() => {
    handleDownloadImage(title, ref);
  }, [title]);

  return (
    <div style={style}>
      <Row justify="end">
        <Col>
          <Button text={'Exportar Gráfico'} clickAction={downloadImage} />
        </Col>
      </Row>
      <Bar
        ref={ref}
        options={options}
        data={dados}
        id="GraficoBarrasVerticalComponenteCanvas"
        data-testid="GraficoBarrasVerticalComponenteCanvas"
        plugins={[plugin]}
      />
    </div>
  );
};

GraficoBarrasVertical.propTypes = {
  title: PropTypes.string,
  dados: PropTypes.object,
  style: PropTypes.object,
};

GraficoBarrasVertical.defaultProps = {
  // title: '',
  // dados: {},
  // style: {},
};

export default GraficoBarrasVertical;
